export const STORAGE_KEYS = {
  // Auth tokens and session
  AUTH_TOKEN: 'auth_token',
  AUTH_ERROR: 'auth_error',

  // Login state management
  LOGIN_STATE_IN_PROGRESS: 'login_in_progress',

  // User preferences
  USER_PREFERENCES: 'user_preferences',

  // Theme and UI state
  THEME_MODE: 'theme_mode',

  // Cache keys
  USER_CACHE: 'user_cache',

  // Debug and development
  DEBUG_MODE: 'debug_mode',
} as const;

// Helper type for type safety
export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
